// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Ev9n8","offset":"Header_offset__+ggvQ","icon":"Header_icon__us5EK","title":"Header_title__w8Qk6"};